import React, { SyntheticEvent, useEffect } from "react";

import {
  Button,
  Checkbox,
  Dropdown,
  Form,
  FormField,
  FormGroup,
  Input,
  InputProps,
  Label,
} from "semantic-ui-react";

import { useIntl } from "react-intl";

import DateTextBox from "react-lib/apps/common/DateTextBox";

import { LoginInfo } from "./UserProfileFormBasic";

import CardEducationInformation from "react-lib/apps/HISV3/HRM/CardEducationInformation";
import CardExperienceInformation from "react-lib/apps/HISV3/HRM/CardExperienceInformation";
import { EducationDataType, ExperienceDataType } from "../../HISV3/HRM/sequence/EmployeeInfo";

export type UserProfileDetailType = Partial<{
  birthdate: string | null;
  cid: string;
  code: string;
  dob: string;
  email: string;
  first_name: string;
  first_name_en: string;
  image: string;
  last_name: string;
  last_name_en: string;
  licence: string;
  phone_no: string;
  status: string;
  user: string;
  // Employment Information
  certificate_no: string;
  doctor_code: string;
  specialties: string;
  flag_start_date: string;
  flag_end_date: string;
  inactive_reason: string;
  doctor_id: string;
  doctor_first_name: string;
  doctor_last_name: string;
  // employee
  employeeId: number;
  // education
  education: Record<string, any>[];
  // experience
  experience: Record<string, any>[];
}>;

type DropdownItemProps = {
  key: string | number;
  value: any;
  text: string;
};

type UserProfileFormDetailedProps = {
  isSaveLoading: boolean;
  isProvider: boolean;
  loginInfo: LoginInfo;
  readOnly?: boolean;
  userData: UserProfileDetailType;
  specialtyOptions?: DropdownItemProps[];
  eduCategoryOptions?: DropdownItemProps[];
  onChangeValue: (e: any, data: any) => void;
  onSave: () => void;
  onCreateUpdateEmployeeEducationInfo: (
    educationData: EducationDataType,
    callback?: (result: { success: boolean }) => void
  ) => void;
  onDeleteEmployeeEducationInfo: (id: number) => void;
  onCreateUpdateEmployeeExperienceInfo: (
    experienceData: ExperienceDataType,
    callback?: (result: { success: boolean }) => void
  ) => void;
  onDeleteEmployeeExperienceInfo: (id: number) => void;
  buttonLoadCheck?: Record<string, any>;
  controller?: any;
  languageUX: "th" | "en";
};

const UserProfileFormDetailed: React.FC<UserProfileFormDetailedProps> = (props) => {
  const intl = useIntl();

  const handleChangeCID = (e: SyntheticEvent, data: InputProps) => {
    let value: string = data.value || "";

    value = value.replace(/\D/g, "").slice(0, 13) || "";

    props.onChangeValue(e, { ...data, value });
  };

  return (
    <div className="employee-info-management">
      <div className="ui form" id="UserProfileFormDetailed">
        <Form className="form-detailed --override-disabled --grey">
          <FormGroup inline>
            <FormField width={8} inline>
              <label>ID</label>
              <Input value={props.userData.code} readOnly />
            </FormField>
            <FormField width={1} />
            <FormField width={8} inline>
              {!!props.loginInfo.loginDisplay?.method && (
                <Label size="large">Login with {props.loginInfo.loginDisplay.method}</Label>
              )}
            </FormField>
          </FormGroup>

          <FormGroup inline>
            <FormField width={8} required>
              <label>ชื่อ</label>
              <Input
                name="first_name"
                placeholder="กรุณาระบุชื่อ"
                readOnly={props.readOnly}
                value={props.userData.first_name}
                fluid
                onChange={props.onChangeValue}
              />
            </FormField>
            <FormField width={1} />
            <FormField width={8} required>
              <label>นามสกุล</label>
              <Input
                name="last_name"
                placeholder="กรุณาระบุนามสกุล"
                readOnly={props.readOnly}
                value={props.userData.last_name}
                fluid
                onChange={props.onChangeValue}
              />
            </FormField>
          </FormGroup>

          <FormGroup inline>
            <FormField width={8} required>
              <label>Firstname</label>
              <Input
                name="first_name_en"
                placeholder="กรุณาระบุชื่อภาษาอังกฤษ"
                readOnly={props.readOnly}
                value={props.userData.first_name_en}
                fluid
                onChange={props.onChangeValue}
              />
            </FormField>
            <FormField width={1} />
            <FormField width={8} required>
              <label>Lastname</label>
              <Input
                name="last_name_en"
                placeholder="กรุณาระบุนามสกุลภาษาอังกฤษ"
                readOnly={props.readOnly}
                value={props.userData.last_name_en}
                fluid
                onChange={props.onChangeValue}
              />
            </FormField>
          </FormGroup>

          <FormGroup inline>
            <FormField width={8}>
              <label>{intl.formatMessage({ id: "เลขประจำตัวประชาชน" })}</label>
              <Input
                name="cid"
                placeholder={intl.formatMessage({ id: "กรุณาระบุเลขประจำตัวประชาชน" })}
                readOnly={props.readOnly}
                value={props.userData.cid}
                fluid
                onChange={handleChangeCID}
              />
            </FormField>
            <FormField width={1} />
            <FormField width={8} required>
              <label>{intl.formatMessage({ id: "profile.day_month_year_birth" })}</label>
              <DateTextBox
                style={{ color: "rgba(0,0,0,.87)" }}
                disabled={props.readOnly}
                placeholder="เลือกวันที่"
                value={props.userData.birthdate}
                onChange={(value) => {
                  props.onChangeValue(null, { name: "birthdate", value });
                }}
              />
            </FormField>
          </FormGroup>

          <FormGroup inline>
            <FormField width={8} required>
              <label>Email</label>
              <Input
                name="email"
                placeholder="กรุณาระบุอีเมลให้ถูกต้อง"
                readOnly={props.readOnly}
                value={props.userData.email}
                onChange={props.onChangeValue}
              />
            </FormField>
            <FormField width={1} />
            <FormField width={8} required>
              <label>เบอร์โทร</label>
              <Input
                name="phone_no"
                placeholder="กรุณาระบุหมายเลขโทรศัพท์"
                readOnly={props.readOnly}
                value={props.userData.phone_no}
                onChange={props.onChangeValue}
              />
            </FormField>
          </FormGroup>
        </Form>
      </div>

      <div style={{ ...(!props.isProvider && { display: "none" }) }}>
        <div style={{ margin: "20px 0px 10px" }}>
          <label style={{ color: "var(--primary-theme-color)", fontWeight: "bold" }}>
            {props.languageUX === "en" ? "Employment Information" : "ข้อมูลการจ้างงาน"}
          </label>
        </div>
        <div className="ui form" id="UserProfileFormDetailed">
          <Form className="form-detailed --override-disabled --grey">
            <FormGroup>
              <FormField className={`required`} style={{ position: "relative" }} width={4}>
                <label style={{ minWidth: "max-content", fontWeight: "normal" }}>
                  {props.languageUX === "en" ? "Medical license" : "ใบอนุญาตประกอบวิชาชีพ"}
                </label>
                <Input
                  fluid
                  name="certificate_no"
                  onChange={props.onChangeValue}
                  value={props.userData?.certificate_no ?? ""}
                ></Input>
              </FormField>
              <FormField className={`required`} style={{ position: "relative" }} width={4}>
                <label style={{ minWidth: "max-content", fontWeight: "normal" }}>
                  {props.languageUX === "en" ? "Doctor code" : "รหัสผู้ให้บริการ"} 
                </label>
                <Input
                  fluid
                  name="doctor_code"
                  onChange={props.onChangeValue}
                  value={props.userData?.doctor_code ?? ""}
                ></Input>
              </FormField>
              <FormField className={`required`} style={{ position: "relative" }} width={8}>
                <label style={{ minWidth: "max-content", fontWeight: "normal" }}>
                  {props.languageUX === "en" ? "Specialty" : "ความเชี่ยวชาญ"}
                </label>
                <Dropdown
                  fluid
                  multiple
                  selection
                  clearable
                  name="specialties"
                  onChange={props.onChangeValue}
                  options={props.specialtyOptions || []}
                  style={{ width: "100%" }}
                  value={props.userData?.specialties ?? ""}
                ></Dropdown>
              </FormField>
            </FormGroup>
            <FormGroup>
              <FormField className={`required`} style={{ position: "relative" }} width={4}>
                <label style={{ minWidth: "max-content", fontWeight: "normal" }}>
                  {props.languageUX === "en" ? "Employment start date" : "วันที่เริ่มงาน"}
                </label>
                <div style={{ width: "100%" }}>
                  <DateTextBox
                    onChange={(value: any) =>
                      props.onChangeValue?.(null, { name: "flag_start_date", value })
                    }
                    style={{ color: "rgba(0,0,0,.87)" }}
                    value={props.userData?.flag_start_date ?? ""}
                  ></DateTextBox>
                </div>
              </FormField>
              <FormField className={`required`} style={{ position: "relative" }} width={4}>
                <label style={{ minWidth: "max-content", fontWeight: "normal" }}>
                  {props.languageUX === "en" ? "Employment end date" : "วันสิ้นสุดการจ้างงาน"}
                </label>
                <div style={{ width: "100%" }}>
                  <DateTextBox
                    onChange={(value: any) =>
                      props.onChangeValue?.(null, { name: "flag_end_date", value })
                    }
                    style={{ color: "rgba(0,0,0,.87)" }}
                    value={props.userData?.flag_end_date ?? ""}
                  ></DateTextBox>{" "}
                </div>
              </FormField>
              <FormField width={8}>
                <label style={{ minWidth: "max-content", fontWeight: "normal" }}>
                  {props.languageUX === "en" ? "Reason" : "เหตุผล"}
                </label>
                <Input
                  fluid
                  name="inactive_reason"
                  onChange={props.onChangeValue}
                  value={props.userData?.inactive_reason ?? ""}
                ></Input>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <CardEducationInformation
          setProp={props.controller?.setProp}
          employeeId={props.userData?.employeeId}
          eduCategoryOption={props.eduCategoryOptions}
          education={props.userData?.education}
          birthDate={props.userData?.dob}
          buttonLoadCheck={props.buttonLoadCheck}
          saveEducationData={(
            educationData: EducationDataType,
            callback?: (result: { success: boolean }) => void
          ) => {
            props.onCreateUpdateEmployeeEducationInfo(educationData, callback);
          }}
          deleteEducationData={(id: number) => {
            props.onDeleteEmployeeEducationInfo(id);
          }}
          languageUX={props.languageUX}
        />
        <CardExperienceInformation
          setProp={props.controller?.setProp}
          employeeId={props.userData?.employeeId}
          experience={props.userData?.experience}
          birthDate={props.userData?.dob}
          buttonLoadCheck={props.buttonLoadCheck}
          saveExperienceData={(
            experienceData: ExperienceDataType,
            callback?: (result: { success: boolean }) => void
          ) => {
            props.onCreateUpdateEmployeeExperienceInfo(experienceData, callback);
          }}
          deleteExperienceData={(id: number) => {
            props.onDeleteEmployeeExperienceInfo(id);
          }}
          languageUX={props.languageUX}
        />
      </div>
      <br />
      <br />

      {!props.readOnly && (
        <div className="last-div">
          <Button
            style={{ backgroundColor: "var(--primary-theme-color)", color: "white" }}
            loading={props.isSaveLoading}
            type="submit"
            onClick={props.onSave}
          >
            บันทึก
          </Button>
        </div>
      )}
    </div>
  );
};

export default UserProfileFormDetailed;
